import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Network } from '@ionic-native/network';
import { Platform } from 'ionic-angular';

/*
  Generated class for the NetworkConnectionProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
declare var Connection;

@Injectable()
export class NetworkConnectionProvider {

  //Variabile indica se la nostra connessione e' attiva o meno
  private isConnect: boolean;
  //verifica se siamo su browser o dispositivo mobile
  private isDevice: boolean;

  constructor(public http: Http, private network: Network, private platform: Platform) {
    this.getConnection(); //verifico la connessione
    this.isDevice = this.platform.is('mobile');
    //console.log('Hello NetworkConnectionProvider Provider, we are connected? '+ this.network.type);
  }

  ionViewDidEnter() {
  }

   /**
  * Metodo che si mette in ascolto di cambiamenti nella connessione
  * permette di abilitare\disabilitare alcune funzionalità dell'app
  */
  private getConnection() {

    
      //check if is mobile device or not, on browser use navigator.online property
      if (!this.isDevice)
          this.isConnect = navigator.onLine;
      else
          this.isConnect = this.network.type !== Connection.NONE ? true : false;
      
    // watch network for a disconnect
    let disconnectSubscription = this.network.onDisconnect().subscribe(() => {
      console.log('network was disconnected :-(');
          this.isConnect = false;
    });

    // watch network for a connection
    let connectSubscription = this.network.onConnect().subscribe(() => {
      console.log('network connected!');
          this.isConnect = true;
    });

  }

  /**
   * Metodo di verifica della connessione, 
   * restituisce true se attiva, false altrimenti
   */
  verifyConnection(): boolean {
    return this.isConnect;
  }

  /**
   * Restituisce il tipo di connessione, se presente
   */
  getTypeConnection(): string {
    return this.network.type;
  }


}



// WEBPACK FOOTER //
// ./src/providers/network-connection/network-connection.ts